<template>
  <SettingEditLayout
    title="提出物の締めと社内カレンダー"
    summary="提出ガイドの締めと、ダッシュボードに出すカレンダーです。"
    :fields="fields"
    :validate="validate"
  >
    <template #default="{ form }">
      <section class="block">
        <h3>提出物の締め</h3>
        <p class="block__desc">
          提出ガイドに出す期限です。<b>未設定の場合は期限を表示しません。</b>
        </p>

        <label for="due-kind">数え方</label>
        <CSelect
          id="due-kind"
          :options="dueKindOptions"
          :value="form.submission_due_kind"
          @update:value="value => chooseDueKind(form, value)"
        />

        <template v-if="form.submission_due_kind">
          <label for="due-day">日</label>
          <CInput
            id="due-day"
            v-model="form.submission_due_day"
            type="number"
            min="1"
            max="31"
            description="1〜31の数字で、翌月の指定日（または第N営業日）を設定します。"
          />
        </template>

        <label for="due-items">そのとき出すもの</label>
        <CInput
          id="due-items"
          v-model.trim="form.submission_due_items"
          maxlength="200"
          description="例: 勤務表・業務報告・経費精算"
        />
      </section>

      <section class="block">
        <h3>ダッシュボードの社内カレンダー</h3>
        <p class="block__desc">
          Google カレンダーの埋め込みURLだけを受け付けます。
          <b>未入力の場合はカレンダーを表示しません。</b>
        </p>
        <label for="calendar-url">埋め込みURL</label>
        <CInput
          id="calendar-url"
          v-model.trim="form.dashboard_calendar_embed_url"
          maxlength="500"
          placeholder="https://calendar.google.com/calendar/embed?..."
        />
      </section>
    </template>
  </SettingEditLayout>
</template>

<script>
import SettingEditLayout from '../SettingEditLayout.vue'
import { findSection } from '../settingSections'
import { selectedValue } from '@/utils/coreuiSelect'

export default {
  name: 'DisplaySettingEdit',
  components: { SettingEditLayout },

  data () {
    return {
      fields: findSection('display').fields,
      dueKindOptions: [
        { value: '', label: '決めない（期限を出さない）' },
        { value: 'BUSINESS_DAY', label: '翌月の第N営業日まで' },
        { value: 'CALENDAR_DAY', label: '翌月のN日まで' }
      ]
    }
  },

  methods: {
    // **テンプレートから使うので methods に置く。**
    // import しただけの関数は、テンプレートからは見えない。
    selectedValue,

    /**
     * 数え方を選んだとき。
     *
     * **「決めない」を選んだら、日も空にする。**
     * 日の欄は数え方を選んだときだけ出る。前は数え方だけを空にしていて、
     * 見えなくなった日の値が残り、保存が「締めの数え方を選んでください。」で
     * 必ず断られた。日の欄は見えないので消しようがなく、
     * 一度締めを決めた会社は「決めない」へ戻せなかった。
     */
    chooseDueKind (form, value) {
      form.submission_due_kind = selectedValue(value)
      if (!form.submission_due_kind) form.submission_due_day = ''
    },

    validate (form) {
      const kind = String(form.submission_due_kind || '').trim()
      const day = String(form.submission_due_day || '').trim()

      // **数え方と日は対。**片方だけ入れさせない。
      // 片方だけだと期限を出しようがないのに、決めたつもりになる。
      if (kind && !day) return '締めの日を入力してください。'
      if (!kind && day) return '締めの数え方を選んでください。'
      if (day) {
        const number = Number(day)
        if (!Number.isInteger(number) || number < 1 || number > 31) {
          return '締め日は1〜31の範囲で入力してください。'
        }
      }

      const url = String(form.dashboard_calendar_embed_url || '').trim()
      if (url) {
        // **Google カレンダーの埋め込みだけ。**任意のURLを画面へ埋めない。
        if (!/^https:\/\/calendar\.google\.com\//.test(url)) {
          return '社内カレンダーには Google カレンダーの埋め込みURLのみ設定可能です。'
        }
        if (/\s/.test(url)) return '埋め込みURLに空白が入っています。'
      }
      return ''
    }
  }
}
</script>

<style scoped>
.block {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid #ebedef;
}

.block:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.block h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.block__desc {
  margin: 0 0 0.75rem;
  color: #5c6873;
  font-size: 0.875rem;
}

label {
  display: block;
  font-weight: 600;
  margin-top: 0.75rem;
}
</style>
